module.exports = __webpack_public_path__ + "static/twitter_white-ee021d370b168c489c361f33f5d46bbe.png";